<template>
  <div class="operate-dialog-content">
    <div class="cos-tab-about-media">
      <div class="cos-tab-about-logo">
        <img src="~@/assets/images/logo.svg" alt="">
      </div>
      <div class="cos-tab-about-title mb-30">{{$t("cos.cosBrowser")}}</div>
      <div class="cos-tab-about-btn">
        <qc-button type="weak" size="small" @click="downloadClient" :title="$t('cos.client_download')">
          {{$t("cos.client_download")}}
        </qc-button>
        <qc-button type="weak" size="small" @click="openIssue" :title="$t('cos.feedback')">
          {{$t("cos.feedback")}}
        </qc-button>
      </div>
      <div class="cos-tab-about-link">
        <a :href="docUrl" target="_blank">{{$t("cos.instructions")}}</a>
        <!-- <a href="javascript:;" @click="openChangeLog">{{$t("cos.update_log")}}</a> -->
        <a :href="privacyPolicyUrl" target="_blank">{{$t("cos.privacy_policy")}}</a>
      </div>
      <div class="cos-tab-about-copyright">
        <div>Copyright &copy; 2020-{{(new Date()).getFullYear()}} Tencent.</div>
        <div>All Rights Reserved.</div>
      </div>
    </div>
    <changelog :show.sync="changelogShow"></changelog>
  </div>
</template>

<script>
import { config } from '@/scripts/tools/config';

import changelog from './changelog.vue';

export default {
  components: {
    changelog,
  },
  data() {
    return {
      // 关于我们
      docUrl: config.docUrl,
      hasNewVersion: this.$store.hasNewVersion,
      logoClickTimer: 0,
      logoClickTimes: 0,
      changelogShow: false,
      privacyPolicyUrl: `https://${this.$store.officialDomain}/document/product/301/11470`,
    };
  },
  methods: {
    downloadClient() {
      // eslint-disable-next-line max-len
      window.open(`https://${this.$store.officialDomain}/document/product/436/11366#.E4.B8.8B.E8.BD.BD.E5.9C.B0.E5.9D.80`);
    },
    openIssue() {
      window.open('https://github.com/tencentyun/cosbrowser/issues');
    },
    openChangeLog() {
      this.changelogShow = true;
    },
  },
};
</script>

<style>
</style>
